module.exports = __webpack_public_path__ + "img/voc-en.01ef41d5.svg";